export class FillModel {
  constructor(
    public target = '',
    public source = '',
    public fill_type: FillTypeEnum | null = null,
    public partition_by: string[] = [],
    public order_by: string[] = [],
    public value: string | number | null = null,
  ) {}
}

export enum FillTypeEnum {
  FirstValue = 'FIRST_VALUE',
  LastValue = 'LAST_VALUE',
  NthValue = 'NTH_VALUE',
  Avg = 'AVG',
  Constant = 'CONSTANT',
}

export const FillTypeOptions = {
  FIRST_VALUE: {
    name: 'FIRST_VALUE',
    description: 'Fills null value with the first value based on rules',
  },
  LAST_VALUE: {
    name: 'LAST_VALUE',
    description: 'Fills null value with the last value based on rules',
  },
  NTH_VALUE: {
    name: 'NTH_VALUE',
    description: 'Fills null value with the specified N-th value based on rules',
  },
  AVG: {
    name: 'AVG',
    description: 'Fills null value with the average value of column',
  },
  CONSTANT: {
    name: 'CONSTANT',
    description: 'Fills null value with the a specified constant',
  },
};

// [
//     'transformObject' => 'required|array|min:1',
//     'transformObject.*.target' => 'required|string',
//     'transformObject.*.source' => 'required|string',
//     'transformObject.*.fill_type' => ['required', Rule::in('FIRST_VALUE', 'LAST_VALUE', 'NTH_VALUE', 'AVG', 'CONSTANT')],
//     'transformObject.*.partition_by' => 'array',
//     'transformObject.*.order_by' => 'array',
//     'transformObject.*.value' => 'string|number',
// ],

// the target and source are always required can be the same column.
// fill type should be one of the Strings specified
// When fill type is FIRST_VALUE or LAST_VALUE or NTH_VALUE the partition by and order by arrays need to have at least 1 column name (string)
// When fill type is NTH_VALUE the value parameter is required and should always be a number
// When fill type is AVG partition by order by and value are not required
// When fill type is CONSTANT the value parameter is required can be string or number (depending on the source column type)
